module.exports = __webpack_public_path__ + "img/btn2.d1637971.png";